import React from 'react';

import Dropdown from 'components/Toolbar/Shared/Dropdown';
import ColorPickerSection from 'containers/Toolbar/Shared/ColorPicker';
import { ColorPickerProps } from './models';
import styles from './styles.module.scss';

const ColorPicker: React.FunctionComponent<ColorPickerProps & { dataTestId?: string }> = (props) => {
  const { dataTestId = 'colorPicker', ...rest } = props;

  return (
    <Dropdown className={styles.ColorPicker} stopClickPropagation={true} dataTestId={`${dataTestId}-dropdown`}>
      <ColorPickerSection {...rest} dataTestId={dataTestId} />
    </Dropdown>
  );
};

export default ColorPicker;
